import React from "react";
import { UpsellPanelSteps } from "../../../../constants/upsellPanelEnumsAndConstants";

export const Step10LockedContent = ({
  currentStep,
  constants,
  customerServicePhone,
}) => {
    if(currentStep !== UpsellPanelSteps.Step10PastDueStatusPaymentFailed){
        return null;
    }
  return (
      <div className="step10 locked-content-msg">
        <h3>
          Your membership to {constants.InvestsmartGroup} recently failed to
          renew.
        </h3>
        <br />
        <p>
          Please make sure your{" "}
          <a
            href={`/payments`} // Replace with correct routing logic or URL generation
          >
            payment details
          </a>{" "}
          are up to date to continue your membership.
        </p>
        <br />
        <p>Having trouble renewing?</p>
        <p>
          Please contact Member Services on{" "}
          <a href="mailto:support@investsmart.com.au">
            support@investsmart.com.au
          </a>{" "}
          or{" "}
          <a href={`tel:${customerServicePhone.replace(/\s/g, "")}`}>
            {customerServicePhone}
          </a>
        </p>
      </div>
  );
};

